import { Route, Routes } from "react-router-dom";

import { AppShell } from "@/components/AppShell";
import { DetectionList } from "@/pages/DetectionList";
import { InquiryDrillDown } from "@/pages/InquiryDrillDown";
import { LoginPage } from "@/pages/LoginPage";

export default function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<AppShell />}>
        <Route path="/" element={<DetectionList />} />
        <Route path="/inquiry/:inquiry_id" element={<InquiryDrillDown />} />
        <Route
          path="*"
          element={
            <main className="container py-8">
              <p className="text-sm text-muted-foreground">Page not found.</p>
            </main>
          }
        />
      </Route>
    </Routes>
  );
}
